import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "activity-selector",
    template: require('./activity-selector.component.html'),
    styles: [require('./activity-selector.component.css')]
})
export class ActivitySelectorComponent {
    @Input()
    activityTypes: Nema.Crew.Model.ActivityType[];

    selected: Nema.Crew.Model.ActivityType;

    @Input()
    get selectedActivity() {
        return this.selected;
    }

    @Output()
    selectedActivityChange = new EventEmitter<Nema.Crew.Model.ActivityType>();

    set selectedActivity(val) {
        this.selected = val;
        this.selectedActivityChange.emit(this.selected);
    }

    @Input()
    isLoading = false;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/daily-activities/activity-selector.component.ts